import { PAGE_TAB_VALUES, type PageTabValue } from '@constants/pageTabs';

/**
 * Shared market/page availability policy for the widget.
 *
 * Instructions (`適時開示`, `tab=5`) is unavailable for every US instrument.
 * This is a frontend page-access rule (a silent redirect / disabled nav item),
 * not an API error state. Both the navigation component and the route guard
 * consume this single helper so the `US + tab=5` condition is never duplicated.
 *
 * The parser canonicalizes a present `mkt` to uppercase upstream, so this helper
 * compares against the canonical `US` code without re-normalizing. It stays safe
 * for undefined/unsupported markets: those keep every tab available here, while
 * missing/unsupported-market messaging remains owned by param validation.
 */
export const isPageTabAvailableForMarket = (
  tab: PageTabValue,
  mkt: string | undefined,
): boolean => !(mkt === 'US' && tab === PAGE_TAB_VALUES.instructions);
